import { render, staticRenderFns } from "./ManualVideo.vue?vue&type=template&id=4a739532"
import script from "./ManualVideo.vue?vue&type=script&lang=js"
export * from "./ManualVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports